import { Table } from 'antd';
import type { ColumnType, TableProps } from 'antd/lib/table';
import { useStoreActions } from '../../store';
import { useEffect } from 'react';
import type { PaginatedTntTableData } from '../../store/timeInTransit/types';

export interface TntPaginationTableProps {
  data: PaginatedTntTableData[];
  loading?: boolean;
  tableProps?: TableProps<PaginatedTntTableData>;
}

interface EditableColumnType<T> extends ColumnType<T> {
  editable?: boolean;
}

export const TntPaginatedTable = ({ data, loading, tableProps }: TntPaginationTableProps) => {
  const fetchUsers = useStoreActions((actions) => actions.users.fetchUsers);

  useEffect(() => {
    fetchUsers(undefined);
  }, [fetchUsers]);

  const columns: EditableColumnType<PaginatedTntTableData>[] = [
    {
      title: 'Carrier Service Method ID',
      dataIndex: 'carrierServiceMethodId',
      width: '35%',
      editable: true,
      sorter: (a: PaginatedTntTableData, b: PaginatedTntTableData) => {
        return (a.carrierServiceMethodId ?? '').localeCompare(b.carrierServiceMethodId ?? '');
      },
    },
    {
      title: 'Origin Country',
      dataIndex: 'originCountry',
      editable: true,
      sorter: (a: PaginatedTntTableData, b: PaginatedTntTableData) => {
        return (a.originCountry ?? '').localeCompare(b.originCountry ?? '');
      },
    },
    {
      title: 'Origin Postal',
      dataIndex: 'originPostal',
      editable: true,
      sorter: (a: PaginatedTntTableData, b: PaginatedTntTableData) => {
        return (a.originPostal ?? '').localeCompare(b.originPostal ?? '');
      },
    },
    {
      title: 'Destination Country',
      dataIndex: 'destinationCountry',
      editable: true,
      sorter: (a: PaginatedTntTableData, b: PaginatedTntTableData) => {
        return (a.destinationCountry ?? '').localeCompare(b.destinationCountry ?? '');
      },
    },
    {
      title: 'Destination Postal',
      dataIndex: 'destinationPostal',
      editable: true,
      sorter: (a: PaginatedTntTableData, b: PaginatedTntTableData) => {
        return (a.destinationPostal ?? '').localeCompare(b.destinationPostal ?? '');
      },
    },
    {
      title: 'TNT',
      dataIndex: 'tnt',
      editable: true,
      sorter: (a: PaginatedTntTableData, b: PaginatedTntTableData) => {
        return (a.tnt.toString() ?? '').localeCompare(b.tnt.toString() ?? '');
      },
    },
  ];

  return (
    <Table
      pagination={{
        pageSize: 20,
        size: 'small',
      }}
      size="small"
      loading={loading}
      columns={columns}
      dataSource={data}
      //rowKey={(record) => record.carrierServiceMethodId}
      {...tableProps}
    />
  );
};
